import { deepOrange, green, grey, red, yellow } from "@material-ui/core/colors";

import colors from "./colors";

const rAOverrides = {
  RaNotification: {
    success: {
      backgroundColor: green[300],
      color: grey[50],
    },
    info: {
      backgroundColor: yellow[200],
      color: grey[50],
    },
    warning: {
      backgroundColor: deepOrange[200],
      color: grey[50],
    },
    error: {
      backgroundColor: red[300],
      color: grey[50],
    },
  },
  RaDatagrid: {
    headerCell: {
      backgroundColor: grey[300],
      color: grey[700],
    },
  },
  RaBulkActionsToolbar: {
    toolbar: {
      backgroundColor: grey[50],
    },
  },
  RaMenuItemLink: {
    active: {
      color: colors.primary.main,
    },
  },
  RaLayout: {
    root: {
      backgroundColor: colors.background.light,
    },
    content: {
      padding: "16px !important",
    },
    appFrame: {
      marginTop: "0px !important",
      minWidth: "100%",
      width: "fit-content",
    },
  },
  RaSidebar: {
    root: {
      height: "auto",
    },
    drawerPaper: {
      boxShadow: "none !important",
    },
    fixed: {
      position: "relative",
    },
  },
};

export default rAOverrides;
